module.exports = __webpack_public_path__ + "static/media/qrCircle.c36f1efe.png";